import './App.css';
import React, { useState, useEffect } from 'react';
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Import Maintenance Check
import MaintenanceCheck from './Components/MaintenanceCheck';

// Import Admin Components
import AdminLogin from './Components/pages/AdminLogin';
import AdminLayout from './Components/pages/AdminLayout';
import AdminUsers from './Components/pages/AdminUsers';
import AdminMaintenance from './Components/pages/AdminMaintenance';
import AdminSettings from './Components/pages/AdminSettings';
import AdminDashboard from './Components/pages/AdminDashboard';
import Feedback from './Components/FeedBack';

// Import all other components...
import Header from "./Components/Header";
import HomePage from './Components/HomePage';
import SignupPage from './Components/SignupPage';
import AboutPage from './Components/AboutPage';
import HeroSectionOnboarding from './Components/HeroSectionOnboarding';
import HeroSectionPolicy from './Components/HeroSectionPolicy';
import HRDashboard from './Components/HRDashboard';
import OnboardingPage from './Components/OnboardingPage';
import CoreHR from './Components/CoreHR';
import EmployeeLogin from './Components/EmployeeLogin';
import EmployeeDashboard from './Components/EmployeeDashboard';
import ContactPage from './Components/ContactPage';
import HRCopilotFeatures from './Components/HRCopilotFeatures';
import HRChatbot from './Components/HRChatbot';
import PayrollManagement from './Components/PayrollManagement';
import CandidateHiring from './Components/CandidateHiring';
// import WebsiteTranslator from './Components/WebsiteTranslator';
import ProfileSection from './Components/ProfileSection';
import ElfsightChatbot from "./Components/ElfsightChatbot";
import AuthCallback from './Components/AuthCallback';
import ManagerDashboard from './Components/ManagerDashboard';
import ReportManager from './Components/ReportManager';
import ManagerLogin from './Components/ManagerLogin';
import Onboarding from './Components/Onboarding';
import EmployeePortal from './Components/EmployeePortal';
import Requirement from './Components/Requirement';
import CandidateApplyPage from './Components/CandidateApplyPage';
import CalendarPage from './Components/CalendarPage';
import RecruitmentPlatform from './Components/RecruitmentPlatform';
import CandidateSourcing from './Components/CandidateSourcing';
import HiringDashboard from './Components/HiringDashboard';
import AccessRecruitPage from './Components/AccessRecruitPage';
import JobAdvertising from './Components/JobAdvertising';
import AssessmentPage from './Components/AssessmentPage';
import Footer from './Components/Footer';
import PerformanceManagement from './Components/PerformanceManagement';
import Automation from './Components/Automation';
import WorkflowManagement from './Components/WorkflowManagement';
import DocumentManagement from './Components/DocumentManagement';
import ApprovalWorkflow from './Components/ApprovalWorkflow';
import ReportInsights from './Components/ReportInsights';
import TimeAttendance from './Components/TimeAttendance';
import Compliance from './Components/Compliance';
import TrainingDevelopment from './Components/TrainingDevelopment';
import BenefitsAdmin from './Components/BenefitsAdmin';
import CandidateOfferLetter from './Components/CandidateOfferLetter';
import MobileUpload from './Components/MobileUpload';
import HelpCenter from './Components/HelpCenter';
import Blog from './Components/Blog';
import Chatbot from './Components/Chatbot';
import Community from './Components/Community';
import Security from './Components/Security';
import PrivacyPolicy from './Components/PrivacyPolicy';
import CookiePolicy from './Components/CookiePolicy';
import TermsService from './Components/TermsService';
import HRAnalytics from './Components/HRAnalytics';
import Integration from './Components/Integration';
import Payment from './Components/Payment';
import OurJourney from './Components/OurJourney';
import OurCultureValues from './Components/OurCultureValues';
import HRBrowser from './Components/HRBrowser';
import HRTeams from './Components/HRTeams';
import OurMissionAndVision from './Components/OurMissionAndVision';
import HRJobBoard from './Components/HRJobBoard';
import AntiSpamPolicy from './Components/AntiSpamPolicy';
import PricingPage from './Components/PricingPage';
import AutoLoginPage from './Components/AutoLoginPage';
import PricingModule from './Components/PricingModule';
import HRCopilotCarousel from './Components/HRCopilotCarousel';
import HRCopilotOnboarding from './Components/HRCopilotOnboarding';
import HRCopilotFAQ from './Components/HRCopilotFAQ';
import Management from './Components/Management';
import HRCopilotHero from './Components/HRCopilotHero';
import HRCopilotPipeline from './Components/HRCopilotPipeline';
import HRCopilotAutoImport from './Components/HRCopilotAutoImport';
import HRCopilotPrivacySkills from './Components/HRCopilotPrivacySkills';
import HRCopilotAllApps from './Components/HRCopilotAllApps';
import HRCopilotProductivity from './Components/HRCopilotProductivity';
import HRCopilotEnterprise from './Components/HRCopilotEnterprise';
import FeatureShowcase from './Components/FeatureShowcase';
import HRCopilotOnboardingHero from './Components/HRCopilotOnboardingHero';
import PerformanceHero from './Components/PerformanceHero';
import PerformanceFeatures from './Components/PerformanceFeatures';
import HRCopilotLanding from './Components/HRCopilotLanding';
import HRCopilotOnboardingStatus from './Components/HRCopilotOnboardingStatus';
import HRCopilotOnboardingFeatures from './Components/HRCopilotOnboardingFeatures';
import Hero from './Components/Hero';
import HRCopilotScheduling from './Components/HRCopilotScheduling';
import HRCopilotEraSection from './Components/HRCopilotEraSection';
import ContactSection from './Components/ContactSection';
import HRCopilotRequirementSection from './Components/HRCopilotRequirementSection';
import HRBusinessSection from './Components/HRBusinessSection';
import HRNewsletter from './Components/HRNewsletter';
import HRCopilotProfessionals from './Components/HRCopilotProfessionals';
import ContactFormSection from './Components/ContactFormSection';
import AIShareJobSection from './Components/AIShareJobSection';
import ResiStepSection from './Components/ResiStepSection';
import ResoOfferSection from './Components/ResoOfferSection';
import HRCopilotOnboardingSection from './Components/HRCopilotOnboardingSection';
import HRCopilotExploreSection from './Components/HRCopilotOnboardingSection';
import HRCopilotNewsSection from './Components/HRCopilotNewsSection';
import HRCopilotStatsSection from './Components/HRCopilotStatsSection';
import EmployeeHero from './Components/EmployeeHero';
import DocumentHero from './Components/DocumentHero';
import AutomationHero from './Components/AutomationHero';
import BenefitsHero from './Components/BenefitsHero';
import ComplianceHero from './Components/ComplainceHero';
import AttendanceHero from './Components/AttendanceHero';
import WorkflowHero from './Components/WorkflowHero';
import TrainingHero from './Components/TrainingHero';
import ReportsHero from './Components/ReportsHero';
import TestimonialSlider from './Components/TestimonialSlider';
import SectionWiseCode from './Components/SectionWiseCode';
import TimeWiseCode from './Components/TimeWiseCode';
import ComplainceWiseCode from './Components/ComplainceWiseCode';
import BenefitsWiseCode from './Components/BenefitsWiseCode';
import TrainingWiseCode from './Components/TrainingWiseCode';
import ServiceWiseCode from './Components/ServiceWiseCode';
import DocumentWiseCode from './Components/DocumentWiseCode';
import WorkflowWiseCode from './Components/WorkflowWiseCode';
import ApprovalWiseCode from './Components/ApprovalWiseCode';
import CTA from './Components/CTA';
import PerformanceWiseCode from './Components/PerformanceWiseCode';
import EmployeeWiseCode from './Components/EmployeeWiseCode';
import RecuirementWiseCode from './Components/RecuirementWiseCode';
import OnboardWiseCode from './Components/OnboardWiseCode';
import ApprovalHero from './Components/ApprovalHero';
import AuthModal from './Components/HRAuthPage';
import HRPlatformShowcase from './Components/Showcase';
import HRAuthPage from './Components/HRAuthPage';
import ApplicationsPage from './Components/Applications';
import ManagerTeamPage from './Components/ManagerTeamPage';
import Subscription from './Components/Subscription';
import EmployeeDetails from './Components/EmployeeDetails';
import MaintenanceNotice from './Components/MaintenanceNotice';
import HRPricingPage from './Components/HRPricingPage'
import ManagerChats from './Components/ManagerChats';
import TemplateBuilderPage from './Components/TemplateBuilderPage';
import QuantumNav from './Components/QuantumNav';
import AboutFeatures from './Components/AboutFeatures';
import AboutHero from './Components/AboutHero';
import CustomerOutcomeShowcase from './Components/CustomerOutcomeShowcase';
import HumanexAICompanion from './Components/HumanexAICompanion';
import HumanexFAQ from './Components/HumanexFAQ';
import WhereWeWork from './Components/WhereWeWork';
import ScrollToTop from "./Components/ScrollToTop";
import HomePricingSection from './Components/HomePricingSection';
import InterviewPrerequisites from './Components/InterviewPrerequisites';
import Terminate from './Components/Terminate';
import AIInterview from './Components/AIInterview';
import AIInterviewDashboard from './Components/AIInterviewDashboard';
import InterviewLandingPage from './Components/InterviewLandingPage';


function App() {
  const [adminUser, setAdminUser] = useState(null);
  const location = useLocation();

  useEffect(() => {
    // Check if admin is logged in from sessionStorage
    const adminData = sessionStorage.getItem('admin');
    if (adminData) {
      setAdminUser(JSON.parse(adminData));
    }
  }, []);

  const handleAdminLogin = (userData) => {
    setAdminUser(userData);
    sessionStorage.setItem('admin', JSON.stringify(userData));
  };

  const handleAdminLogout = () => {
    setAdminUser(null);
    sessionStorage.removeItem('admin');
  };

  // Protected Route for Admin
  const AdminRoute = ({ children }) => {
    if (!adminUser) {
      return <Navigate to="/admin/login" />;
    }
    return children;
  };

  // Function to check if current route should show Header/Footer/Chatbot
// Function to check if current route should show Header/Footer/Chatbot
const shouldShowLayoutElements = () => {
  const path = location.pathname;

  // ✅ Interview Landing Page hide (IMPORTANT FIX)
  if (path.match(/^\/interview\/[^/]+$/)) {
    return false;
  }

  // ✅ Interview Prerequisites already correct
  if (path.match(/^\/interview\/[^/]+\/prerequisites$/)) {
    return false;
  }

  const hiddenRoutes = [
    '/dashboard',
    '/employeedashboard',
    '/terminated',
    '/managerdashboard',
    '/hiring-dashboard',
    '/admin',
    '/apply',
    '/candidate/offer',
    '/assessment',
    '/auto-login'
  ];

  const isHiddenRoute = hiddenRoutes.some(route =>
    path === route || path.startsWith(`${route}/`)
  );

  const isAdminRoute = path.startsWith('/admin/');

  return !(isHiddenRoute || isAdminRoute);
};

  // Function to check if footer should be hidden (only for /access-recruit)
// Function to check if footer should be hidden
const shouldShowFooter = () => {
  const path = location.pathname;

  // ✅ Interview Landing Page hide
  if (path.match(/^\/interview\/[^/]+$/)) {
    return false;
  }

  // ✅ Prerequisites
  if (path.match(/^\/interview\/[^/]+\/prerequisites$/)) {
    return false;
  }

  const footerHiddenRoutes = [
    '/login',
    '/signup',
    '/access-recruit',
    '/hr-login',
    '/managerlogin',
    '/employeelogin',
    '/onboardingpage',
    '/terminated'
  ];

  const hideFooter = footerHiddenRoutes.some(route =>
    path === route || path.startsWith(`${route}/`)
  );

  return !hideFooter && shouldShowLayoutElements();
};


  const showLayout = shouldShowLayoutElements();
  const showFooter = shouldShowFooter();

  return (
    <div className="App">  
      <ToastContainer position="top-center" />
      
      {/* Wrap entire app with MaintenanceCheck */}
      <MaintenanceCheck>
      {/* ✅ Scroll to top on route change */}
      <ScrollToTop />
        {/* Header visible only on non-dashboard, non-admin routes */}
        {showLayout && <Header />}
        
        {/* Pages handled by routes */}
        <Routes>
          {/* ================= ADMIN ROUTES ================= */}
          <Route 
            path="/admin/login" 
            element={
              adminUser ? 
                <Navigate to="/admin/dashboard" /> : 
                <AdminLogin onLogin={handleAdminLogin} />
            } 
          />
          
          {/* Admin Layout with Sidebar for all admin pages */}
          <Route 
            path="/admin/dashboard" 
            element={
              <AdminRoute>
                <AdminLayout 
                  user={adminUser} 
                  onLogout={handleAdminLogout}
                  activeComponent="dashboard"
                >
                  <AdminDashboard/>
                </AdminLayout>
              </AdminRoute>
            } 
          />

          <Route 
            path="/admin/users" 
            element={
              <AdminRoute>
                <AdminLayout 
                  user={adminUser} 
                  onLogout={handleAdminLogout}
                  activeComponent="users"
                >
                  <AdminUsers />
                </AdminLayout>
              </AdminRoute>
            } 
          />

          <Route 
            path="/admin/maintenance" 
            element={
              <AdminRoute>
                <AdminLayout 
                  user={adminUser} 
                  onLogout={handleAdminLogout}
                  activeComponent="maintenance"
                >
                  <AdminMaintenance />
                </AdminLayout>
              </AdminRoute>
            } 
          />

          <Route 
            path="/admin/settings" 
            element={
              <AdminRoute>
                <AdminLayout 
                  user={adminUser} 
                  onLogout={handleAdminLogout}
                  activeComponent="settings"
                >
                  <AdminSettings user={adminUser} />
                </AdminLayout>
              </AdminRoute>
            } 
          />

          {/* ================= PUBLIC ROUTES ================= */}
          <Route path="/" element={<HomePage />} />
          <Route path="/signuppage" element={<SignupPage />} />
          <Route path="/aboutpage" element={<AboutPage />} />
          <Route path="/herosectiononboarding" element={<HeroSectionOnboarding />} />
          <Route path="/herosectionpolicy" element={<HeroSectionPolicy />} />
          
          <Route path="/aboutfeatures" element={<AboutFeatures />} />

          {/* Dashboard Routes - Header/Footer will be hidden */}
          <Route path="/dashboard" element={<HRDashboard />} />
          <Route path="/employeedashboard" element={<EmployeeDashboard />} />
          <Route path="/employeedashboard/:employeeId" element={<EmployeeDashboard />} />
          <Route path="/managerdashboard" element={<ManagerDashboard />} />
          <Route path="/hiring-dashboard" element={<HiringDashboard />} />

          <Route path="/template-builder" element={<TemplateBuilderPage />} />

<Route path="/terminated" element={<Terminate />} />
<Route path="/ai-interview/:id" element={<AIInterview />} />
          {/* Access Recruit Routes */}
          <Route path="/login" element={<AccessRecruitPage />} />
          <Route path="/signup" element={<AccessRecruitPage />} />
          <Route path="/access-recruit" element={<AccessRecruitPage />} />
          
          <Route path="/onboardingpage" element={<OnboardingPage />} />
          <Route path="/corehr" element={<CoreHR />} />
          <Route path="/employeelogin" element={<EmployeeLogin />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/features" element={<HRCopilotFeatures />} />
          <Route path="/payroll-management" element={<PayrollManagement />} />
          <Route path="/profilesection" element={<ProfileSection />} />
          <Route path="/auth/callback" element={<AuthCallback />} />

          <Route path="/candidate" element={<CandidateHiring />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route path="/employeeportal" element={<EmployeePortal />} />

          <Route path="/feedback" element={<Feedback />} />
          <Route path="/ai-interviews" element={<AIInterviewDashboard />} />

          {/* Candidate Apply Page - Header/Footer Hidden */}
          <Route path="/apply/:requirementId" element={<CandidateApplyPage />} />
          
          <Route path="/calendar-page" element={<CalendarPage />} />
          <Route path="/managerlogin" element={<ManagerLogin />} />
          
          {/* Auto Login Page - Header/Footer Hidden */}
          <Route path="/auto-login" element={<AutoLoginPage />} />
          <Route path="/interview/:interviewId" element={<InterviewLandingPage />} />

<Route path="/interview/:interviewId/prerequisites" element={<InterviewPrerequisites />} />

          <Route path="/report-managers" element={<ReportManager />} />
          <Route path="/requirements" element={<Requirement />} />
          <Route path="/requirement-platform" element={<RecruitmentPlatform />} />
          <Route path="/candidate-sourcing" element={<CandidateSourcing />} />
          <Route path="/jobadvertising" element={<JobAdvertising />} />
          <Route path="/performance-management" element={<PerformanceManagement />} />
          <Route path="/automation" element={<Automation />} />
          <Route path="/workflow-management" element={<WorkflowManagement />} />
          <Route path="/document-management" element={<DocumentManagement />} />
          <Route path="/approval-workflows" element={<ApprovalWorkflow />} />
          <Route path="/reports" element={<ReportInsights />} />
          <Route path="/compliance" element={<Compliance />} />
          <Route path="/training-development" element={<TrainingDevelopment />} />
          <Route path="/benefits-admin" element={<BenefitsAdmin />} />
          <Route path="/help-center" element={<HelpCenter />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/community" element={<Community />} />
          <Route path="/security" element={<Security />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/cookie-policy" element={<CookiePolicy />} />
          <Route path="/terms-service" element={<TermsService />} />
          <Route path="/hranalytics" element={<HRAnalytics />} />
          <Route path="/integrations" element={<Integration />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/our-journey" element={<OurJourney />} />
          <Route path="/ourculture" element={<OurCultureValues />} />
          <Route path="/browser-extensions" element={<HRBrowser />} />
          <Route path="/teams-integration" element={<HRTeams />} />
          <Route path="/mission-vision" element={<OurMissionAndVision />} />
          <Route path="/hr-job-board" element={<HRJobBoard />} />
          <Route path="/anti-spam-policy" element={<AntiSpamPolicy />} />

          <Route path="/pricing" element={<PricingPage />} />
          <Route path="/pricingmodule" element={<PricingModule />} />
          <Route path="/carousal" element={<HRCopilotCarousel />} />
          <Route path="/customeroutcomeshowcase" element={<CustomerOutcomeShowcase />} />
          <Route path="/humanexaicompanion" element={<HumanexAICompanion />} />
          <Route path="/humanexfaq" element={<HumanexFAQ />} />
          <Route path="/HRCopilotonboarding" element={<HRCopilotOnboarding />} />
          <Route path="/HRCopilotFAQ" element={<HRCopilotFAQ />} />
          <Route path="/Management" element={<Management />} />
          <Route path="/HRCopilotHero" element={<HRCopilotHero />} />
          <Route path="/HRCopilotJobStatus" element={<HRCopilotHero />} />
          <Route path="/HRCopilotPipeline" element={<HRCopilotPipeline />} />
          <Route path="/HRCopilotAutoImport" element={<HRCopilotAutoImport />} />
          <Route path="/HRCopilotFeatures" element={<HRCopilotFeatures />} />
          <Route path="/HRCopilotPrivacySkills" element={<HRCopilotPrivacySkills />} />
          <Route path="/HRCopilotAllApps" element={<HRCopilotAllApps />} />
          <Route path="/HRCopilotProductivity" element={<HRCopilotProductivity />} />
          <Route path="/HRCopilotEnterprise" element={<HRCopilotEnterprise />} />
          <Route path="/FeatureShowcase" element={<FeatureShowcase />} />
          <Route path="/HRCopilotOnboardingHero" element={<HRCopilotOnboardingHero />} />
          <Route path="/PerformanceHero" element={<PerformanceHero />} />
          <Route path="/PerformanceFeatures" element={<PerformanceFeatures />} />
          <Route path="/HRCopilotLanding" element={<HRCopilotLanding/>} />
          <Route path="/HRCopilotOnboardingStatus" element={<HRCopilotOnboardingStatus/>} />
          <Route path="/HRCopilotOnboardingPipeline" element={<HRCopilotOnboardingStatus/>} />
          <Route path="/HRCopilotOnboardingFeatures" element={<HRCopilotOnboardingFeatures/>} />
          <Route path="/Hero" element={<Hero />} />
          <Route path="/HRCopilotScheduling" element={<HRCopilotLanding/>} />
          <Route path="/HRCopilotEraSection" element={<HRCopilotEraSection/>} />
          <Route path="/contactsection" element={<ContactSection />} />
          <Route path="/hrcopilotrequirementsection" element={<HRCopilotRequirementSection />} />
          <Route path="/hrbusinesssection" element={<HRBusinessSection />} />
          <Route path="/hrnewsletter" element={<HRNewsletter />} />
          <Route path="/hrcopilotprofessional" element={<HRCopilotProfessionals />} />
          <Route path="/contactformsection" element={<ContactFormSection />} />
          <Route path="/wherewework" element={<WhereWeWork />} />
          <Route path="/homepagepricing" element={<HomePricingSection />} />

          <Route path="/aijoboffersection" element={<AIShareJobSection />} />
          <Route path="/resistepsection" element={<ResiStepSection />} />
          <Route path="/resooffersection" element={<ResoOfferSection />} />
          <Route path="/hrcopilotonboardingsection" element={<HRCopilotExploreSection/>} />

          <Route path="/hrcopilotnewsection" element={<HRCopilotNewsSection/>} />
          <Route path="/hrcopilotstatssection" element={<HRCopilotStatsSection/>} />
          <Route path="/DocumentHero" element={<DocumentHero/>} />
          <Route path="/automationHero" element={<AutomationHero />} />
          <Route path="/WorkflowHero" element={<WorkflowHero />} />
          <Route path="/ComplainceHero" element={<ComplianceHero />} />
          <Route path="/BenefitsHero" element={<BenefitsHero/>} />
          <Route path="/TrainingHero" element={<TrainingHero />} />
          <Route path="/AttendanceHero" element={<AttendanceHero/>} />
          <Route path="/EmployeeheroHero" element={<EmployeeHero />} />
          <Route path="/ReportsHero" element={<ReportsHero />} />
          <Route path="/Testimonialslider" element={<TestimonialSlider />} />
          <Route path="/sectionwisecode" element={<SectionWiseCode />} />
          <Route path="/timewisecode" element={<TimeWiseCode />} />
          <Route path="/complaincewisecode" element={<ComplainceWiseCode />} />
          <Route path="/benefitswisecode" element={<BenefitsWiseCode />} />
          <Route path="/trainingwisecode" element={<TrainingWiseCode />} />
          <Route path="/servicewisecode" element={<ServiceWiseCode />} />
          <Route path="/documentwisecode" element={<DocumentWiseCode />} />
          <Route path="/workflowwisecode" element={<WorkflowWiseCode />} />
          <Route path="/approvalwisecode" element={<ApprovalWiseCode />} />
          <Route path="/cta" element={<CTA />} />
          <Route path="/perfromancewisecode" element={<PerformanceWiseCode />} />
          <Route path="/employeewisecode" element={<EmployeeWiseCode />} />
          <Route path="/recuirementwisecode" element={<RecuirementWiseCode />} />
          <Route path="/onboardwisecode" element={<OnboardWiseCode />} />
          <Route path="/approvalHero" element={<ApprovalHero />} />
          <Route path="/authmodal" element={<AuthModal />} />
          <Route path="/showcase" element={<HRPlatformShowcase />} />
          <Route path="/hr-login" element={<HRAuthPage />} />
          <Route path="/hr-pricing" element={<HRPricingPage />} />
          <Route path="/manager-chats" element={<ManagerChats />} />
          <Route path="/applications" element={<ApplicationsPage />} />
          <Route path="/manager-team" element={<ManagerTeamPage />} />
          <Route path="/maintenancenotice" element={<MaintenanceNotice />} />

          <Route path="/abouthero" element={<AboutHero />} />

          <Route path="/hr-subscription" element={<Subscription />} />
          <Route path="/employee-details" element={<EmployeeDetails />} />

          {/* Routes with Header/Footer Hidden */}
          <Route path="/mobile-upload" element={<MobileUpload />} />
          <Route path="/time-attendance" element={<TimeAttendance />} />
          <Route path="/candidate/offer/:offerLetterId" element={<CandidateOfferLetter />} />
          <Route path="/assessment/:assessmentId" element={<AssessmentPage />} />

        </Routes>

        {/* Show chatbot only on non-dashboard, non-admin routes */}
        {showLayout && <Chatbot />}
        
        {/* Show footer only on non-dashboard, non-admin routes AND NOT on /access-recruit */}
        {showFooter && <Footer />}
      </MaintenanceCheck>
    </div>
  );
}

export default App;